module.exports = __webpack_public_path__ + "static/OneDot.a66c9bc9.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDot.eot
// module id = 735
// module chunks = 114276838955818